import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3037ff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Faq" }
const _hoisted_2 = {
  class: "Faq-intro padded",
  "data-scroll-section": ""
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: "Faq-content grid padded",
  "data-scroll-section": ""
}
const _hoisted_5 = { class: "Faq-content-left" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "Faq-content-right" }
const _hoisted_8 = { class: "Faq-collapse-header" }
const _hoisted_9 = { class: "Faq-collapse-header-title h4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Faq-collapse-header-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "17",
    height: "14",
    fill: "#111",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 .636a.5.5 0 0 1 .706.021l5.658 6a.5.5 0 0 1 0 .686l-5.658 6a.5.5 0 0 1-.728-.686L14.841 7.5H1a.5.5 0 0 1 0-1h13.841L9.978 1.343A.5.5 0 0 1 10 .636Z"
    })
  ])
], -1))
const _hoisted_11 = { class: "Faq-collapse-content" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Collapse = _resolveComponent("Collapse")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("h1", {
            class: "Faq-intro-title h1 h1--big",
            innerHTML: _ctx.$t('faqs.title')
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: "text-lg",
              innerHTML: _ctx.$t('faqs.description')
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (n) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (![20, 21, 22, 23].includes(n))
                  ? (_openBlock(), _createBlock(_component_Collapse, {
                      key: n,
                      class: "Faq-collapse"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('faqs.question'+n)), 1),
                          _hoisted_10
                        ])
                      ]),
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", {
                            class: "text-lg",
                            innerHTML: _ctx.$t('faqs.answer'+n)
                          }, null, 8, _hoisted_12)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}